/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ProcessActionService extends services.DataService<Wars.Domain.Model.ProcessAction> {

        constructor(
            injectedBreeze: typeof breeze,
            $q: angular.IQService,
            private $http: angular.IHttpService,
            private worflowService: services.WorkflowService)
        {
            super(injectedBreeze, $q);
        }

        public getAllProcessActions(processConfigId: string): ng.IPromise<Wars.Domain.Model.ProcessAction[]> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessActions")
                .where("processConfiguration_id", "==", processConfigId)
                .orderBy("name");

            return this.executeQuery(query);
        }

        public createNewProcessAction(processConfigId: string): Wars.Domain.Model.ProcessAction {
            var newProcessAction = this.createNewEntity<Wars.Domain.Model.ProcessAction>("ProcessAction");
            newProcessAction.name = "New Process Action";
            newProcessAction.processConfiguration_id = processConfigId;

            var newStartProcessActionWorkflowBlock = this.createNewEntity<Wars.Domain.Model.Workflow.Blocks.StartProcessActionWorkflowBlock>("StartProcessActionWorkflowBlock");
            newStartProcessActionWorkflowBlock.blockType = Wars.Domain.Model.Codes.Enums.BlockType.StartProcessAction;
            newStartProcessActionWorkflowBlock.uniqueIdentifier = UtilityService.generateGuidComb();
            newStartProcessActionWorkflowBlock.myProcessAction = newProcessAction;
            newStartProcessActionWorkflowBlock.isInitialWorkflowBlock = true;
            newStartProcessActionWorkflowBlock.name = "Start";
            newStartProcessActionWorkflowBlock.description = "Entry point to the Process Action";

            newProcessAction.myWorkflowBlocks.push(newStartProcessActionWorkflowBlock);

            return newProcessAction;
        }

        public getProcessActionGroup(processActionId: string): ng.IPromise<models.ProcessActionGroup> {
            var d = this.$q.defer();

            this.$http.get('./api/ProcessAction/' + processActionId).then(
                (result: any) => {
                    var processActionGroupDto: Wars.Domain.Model.Dtos.Workflow.ProcessActionGroupDto = result.data;
                    var processActionGroup = new models.ProcessActionGroup();
                    var blocks = this.worflowService.bindBlockList(processActionGroupDto.workflowBlocks);
                    processActionGroup.intitialize(processActionGroupDto, blocks);
                    d.resolve(processActionGroup);
                });

            return d.promise;
        }
    }
}

warsApp.registerService('ProcessActionService', ['breeze', '$q', '$http', 'workflowService']);